import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';

/**
 * Route guard — redirects unauthenticated users to /login.
 * Shows the Pulse loading spinner during auth initialization.
 */
export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-[#0B0D10] flex items-center justify-center z-50">
        <div className="text-center">
          <div className="relative mb-6">
            <div className="w-16 h-16 rounded-full border-2 border-[#A38BFF]/20 flex items-center justify-center">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#A38BFF] to-[#7B68EE] animate-pulse" />
            </div>
            <div className="absolute inset-0 rounded-full border-2 border-[#A38BFF] border-t-transparent animate-spin" />
          </div>
          <h1 className="text-2xl font-bold text-[#F5F7FF] tracking-tight">Pulse</h1>
          <p className="text-sm text-[#A7B0C8] mt-2">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirect = location.pathname + location.search;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
  }

  return <>{children}</>;
}
